export var ERepeatPolicy;
(function (ERepeatPolicy) {
  ERepeatPolicy["OnError"] = "onError";
  ERepeatPolicy["Always"] = "always";
})(ERepeatPolicy || (ERepeatPolicy = {}));